import {
  Select,
  SelectBackdrop,
  SelectContent,
  SelectDragIndicator,
  SelectDragIndicatorWrapper,
  SelectInput,
  SelectItem,
  SelectPortal,
  SelectTrigger,
  View,
} from '@gluestack-ui/themed'
import I18n from 'i18n-js'
import React, { useState } from 'react'
import { StyleSheet } from 'react-native'
import Ionicons from 'react-native-vector-icons/Ionicons'

interface Props {
  onLanguageChange?: () => void
}

export function ChangeLanguage(props: Props) {
  const [language, setLanguage] = useState(I18n.currentLocale())

  const handleValueChange = (value: string) => {
    I18n.locale = value
    setLanguage(value)
    if (props.onLanguageChange) {
      props.onLanguageChange()
    }
    // eslint-disable-next-line  @typescript-eslint/ban-ts-comment
    // @ts-ignore Todo: Update I18n typings
    return I18n.t.cache.clear()
  }

  return (
    <Select selectedValue={language} onValueChange={handleValueChange}>
      <SelectTrigger style={styles.trigger}>
        <SelectInput testID="changeLanguagePicker" />
        <View style={styles.icon}>
          <Ionicons name="chevron-down" size={16} />
        </View>
      </SelectTrigger>
      <SelectPortal>
        <SelectBackdrop />
        <SelectContent>
          <SelectDragIndicatorWrapper>
            <SelectDragIndicator />
          </SelectDragIndicatorWrapper>
          <SelectItem label="FR" value="fr" />
          <SelectItem label="EN" value="en" />
        </SelectContent>
      </SelectPortal>
    </Select>
  )
}

const styles = StyleSheet.create({
  trigger: {
    height: 50,
    width: 100,
  },
  icon: {
    paddingRight: 8,
  },
})
